import React from 'react';

// STYLES
import styles from './overviewToolbar.module.scss';

const Item = ({ children, label, value = children }) => (
  <div className={styles.item}>
    <span className={styles.label}>{label}</span>
    <span className={styles.value}>{value}</span>
  </div>
);

// MAIN COMPONENT
const OverviewToolbar = dataArray => {
  const [data = {}] = dataArray || [];
  return (
    <div className={styles.toolbar}>
      <Item label="Sold">{data.totalday_sold}</Item>
      <Item label="AM/FI">{data.totalday_amfi}</Item>
      <Item label="Fallout">{data.totalday_fallout}</Item>
      <Item label="Order">{data.totalday_order}</Item>
      <Item label="Delivered">{data.totalday_delivered}</Item>
      <Item label="Backout">{data.totalday_backout}</Item>
      <Item label="Net">{data.totalday_net}</Item>
    </div>
  );
};

// EXPORT
export default OverviewToolbar;
